
import { useI18n } from "vue-i18n";
import { defineComponent, defineAsyncComponent } from "vue";
import locales from "@/utils/Locales";

export default defineComponent({
  name: "Agreement",
  setup() {
    const { t } = useI18n({ useScope: "global" });

    const cookieLocale = locales.initLocale();
    console.log(cookieLocale, "cookieLocale");

    const agreementContent = locales.isKorean(cookieLocale)
      ? defineAsyncComponent(() => import("./agreements/ko.vue"))
      : locales.isUzbek(cookieLocale)
      ? defineAsyncComponent(() => import("./agreements/uz.vue"))
      : locales.isRussian(cookieLocale)
      ? defineAsyncComponent(() => import("./agreements/ru.vue"))
      : defineAsyncComponent(() => import("./agreements/en.vue"));

    return { t, agreementContent };
  },
});
